<form [formGroup]="realEstateDetailForm">
  <div class="grid-container">
    <div class="grid-item state formField userInput" *ngIf="!pId">
      <mat-form-field>
        <mat-label> State </mat-label>
        <mat-select formControlName="state" required>
          <mat-option *ngFor="let state of states" [value]="state.value">
            {{ state.viewValue }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="grid-item state formField readOnlyInput" *ngIf="!!pId">
      <mat-form-field>
        <mat-label> State </mat-label>
        <input readonly matInput formControlName="state" />
      </mat-form-field>
    </div>
    <div class="grid-item department formField userInput" *ngIf="!pId">
      <mat-form-field>
        <mat-label> Department Creating the SPAR </mat-label>
        <mat-select formControlName="department" required>
          <mat-option
            *ngFor="let department of departments"
            [value]="department.viewValue"
          >
            {{ department.viewValue }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="grid-item department formField readOnlyInput" *ngIf="!!pId">
      <mat-form-field>
        <mat-label> Department Creating the SPAR </mat-label>
        <input readonly matInput formControlName="department" />
      </mat-form-field>
    </div>
    <div class="grid-item adaptiveId formField userInput">
      <!-- Conditionally show the adaptiveId input or the Create Project ID button -->
      <ng-container *ngIf="!fm; else createProjectIdButton">
        <mat-form-field>
          <mat-label>Adaptive Work ID</mat-label>
          <input
            matInput
            formControlName="adaptiveId"
            (click)="onAdaptiveIdClick()"
            placeholder="Enter Adaptive Work ID"
            required
          />
          <mat-error
            *ngIf="
              realEstateDetailForm.get('adaptiveId')?.hasError('minlength') ||
              realEstateDetailForm.get('adaptiveId')?.hasError('maxlength')
            "
          >
            Adaptive ID must be exactly 12 characters long.
          </mat-error>
        </mat-form-field>
      </ng-container>
      <!-- Button to create a project ID (hidden in review mode) -->
      <ng-template #createProjectIdButton>
        <button
          *ngIf="!reviewMode"
          type="button"
          class="formButton formButtonText"
          (click)="createProjectId()"
          [disabled]="!!realEstateDetailForm.get('projectId')?.value"
          [class.disabled-create-project-id-button]="
            !!realEstateDetailForm.get('projectId')?.value
          "
        >
          Create Project ID
        </button>
      </ng-template>
    </div>
    <div class="grid-item projectId formField readOnlyInput">
      <mat-form-field>
        <mat-label> Project ID </mat-label>
        <input readonly matInput formControlName="projectId" />
      </mat-form-field>
    </div>
    <div class="grid-item buildings formField userInput" *ngIf="!reviewMode">
      <mat-form-field>
        <mat-label> Building Name </mat-label>
        <mat-select formControlName="building" required>
          <!-- Search Input -->
          <mat-option>
            <input
              matInput
              placeholder="Search buildings"
              [formControl]="buildingSearchControl"
              (input)="filterBuildings()"
              (click)="$event.stopPropagation()"
              (keydown.space)="$event.stopPropagation()"
            />
          </mat-option>
          <!-- Filtered Options -->
          <mat-option
            *ngFor="let building of filteredBuildingDetails"
            [value]="building.building_name"
          >
            {{ building.building_name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="grid-item buildings formField readOnlyInput" *ngIf="reviewMode">
      <mat-form-field>
        <mat-label> Building Name </mat-label>
        <input readonly matInput formControlName="building" />
      </mat-form-field>
    </div>
    <div class="grid-item assetLocation formField readOnlyInput">
      <mat-form-field>
        <mat-label> Asset Location </mat-label>
        <input readonly matInput formControlName="assetLocation" />
      </mat-form-field>
    </div>
    <div class="grid-item majorLocation formField readOnlyInput">
      <mat-form-field>
        <mat-label> Major Location </mat-label>
        <input readonly matInput formControlName="majorLocation" />
      </mat-form-field>
    </div>
    <div class="grid-item city formField readOnlyInput">
      <mat-form-field>
        <mat-label> City </mat-label>
        <input readonly matInput formControlName="city" />
      </mat-form-field>
    </div>
    <div class="grid-item businessUnit formField readOnlyInput">
      <mat-form-field>
        <mat-label> Business Unit </mat-label>
        <input readonly matInput formControlName="businessUnit" />
      </mat-form-field>
    </div>
    <div class="grid-item fundingProject formField readOnlyInput">
      <mat-form-field>
        <mat-label>Funding Project</mat-label>
        <input
          type="text"
          matInput
          formControlName="fundingProject"
          [matAutocomplete]="autoFundingProject"
        />
        <mat-autocomplete #autoFundingProject="matAutocomplete">
          <mat-option
            *ngFor="let project of fundingProjects"
            [value]="project.fundingProject"
          >
            {{ project.fundingProject }}
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
    </div>
    <div class="grid-item projectType formField readOnlyInput">
      <mat-form-field>
        <mat-label> Project Type </mat-label>
        <input readonly matInput formControlName="projectType" />
      </mat-form-field>
    </div>
    <div class="grid-item projectClass formField userInput">
      <mat-form-field>
        <mat-label> Project Class </mat-label>
        <mat-select formControlName="projectClass" required>
          <mat-option *ngFor="let class of projectClass" [value]="class.value">
            {{ class.value }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="grid-item isLocationLeased formField">
      <mat-checkbox formControlName="isLocationLeased">
        Is this a leased location?
      </mat-checkbox>
    </div>

    <div
      class="grid-item leaseStartDate formField"
      *ngIf="realEstateDetailForm.get('isLocationLeased')?.value"
    >
      <mat-form-field>
        <mat-label>Lease Start Date</mat-label>
        <input
          matInput
          [matDatepicker]="leaseStartPicker"
          formControlName="leaseStartDate"
          style="color: #696969"
        />
        <mat-datepicker-toggle
          matSuffix
          [for]="leaseStartPicker"
        ></mat-datepicker-toggle>
        <mat-datepicker #leaseStartPicker></mat-datepicker>
      </mat-form-field>
    </div>

    <div
      class="grid-item leaseEndDate formField"
      *ngIf="realEstateDetailForm.get('isLocationLeased')?.value"
    >
      <mat-form-field>
        <mat-label>Lease End Date</mat-label>
        <input
          matInput
          [matDatepicker]="leaseEndPicker"
          formControlName="leaseEndDate"
          [min]="realEstateDetailForm.get('leaseStartDate')?.value"
          style="color: #696969"
        />
        <mat-datepicker-toggle
          matSuffix
          [for]="leaseEndPicker"
        ></mat-datepicker-toggle>
        <mat-datepicker #leaseEndPicker></mat-datepicker>
      </mat-form-field>
    </div>
  </div>
  <div>
    <div class="formSubHeader">
      <span> Project Description </span>
    </div>
    <div class="formSubHeader">
      <textarea
        class="textarea"
        formControlName="projectDescription"
        maxlength="255"
        [readonly]="reviewMode"
        [class.disabledField]="reviewMode"
      ></textarea>
    </div>
    <div class="formSubHeader">
      <span
        >{{ descriptionLength() }} characters (maximmum 255 characters)</span
      >
    </div>
  </div>
  <div>
    <div class="formSubHeader">
      <span> Contacts </span>
    </div>
    <div class="grid-container-contacts">
      <div class="grid-item projectManager formField userInput">
        <mat-form-field>
          <mat-label> Project Manager (PM) </mat-label>
          <!-- Search Input -->
          <input
            type="text"
            matInput
            formControlName="projectManager"
            [matAutocomplete]="projectManagerAuto"
          />
          <!-- Filtered Options -->
          <mat-autocomplete
            requireSelection
            #projectManagerAuto="matAutocomplete"
            [displayWith]="displayUser"
          >
            <mat-option
              *ngFor="let user of filteredProjectManagerUserDetails"
              [value]="user"
              style="line-height: 16px"
            >
              <div class="user-option">
                <span class="user-display-name">{{ user.displayName }}</span>
                <span class="user-mail">{{ user.mail }}</span>
              </div>
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div>
      <div class="grid-item sponsor formField userInput">
        <mat-form-field>
          <mat-label>Sponsor</mat-label>
          <!-- Search Input -->
          <input
            type="text"
            matInput
            formControlName="sponsor"
            [matAutocomplete]="sponsorAuto"
            placeholder="Search for a contact"
          />
          <!-- Filtered Options -->
          <mat-autocomplete
            requireSelection
            #sponsorAuto="matAutocomplete"
            [displayWith]="displayUser"
          >
            <mat-option
              *ngFor="let user of filteredSponsorUserDetails"
              [value]="user"
              style="line-height: 16px"
            >
              <div class="user-option">
                <span class="user-display-name">{{ user.displayName }}</span>
                <span class="user-mail">{{ user.mail }}</span>
              </div>
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div>
      <div class="grid-item contractAdmin formField userInput">
        <mat-form-field>
          <mat-label> Contract Admin (JLL PC/FC) </mat-label>
          <!-- Search Input -->
          <input
            type="text"
            matInput
            formControlName="contractAdmin"
            [matAutocomplete]="contractAdminAuto"
          />
          <!-- Filtered Options -->
          <mat-autocomplete
            requireSelection
            #contractAdminAuto="matAutocomplete"
            [displayWith]="displayUser"
          >
            <mat-option
              *ngFor="let user of filteredContractAdminUserDetails"
              [value]="user"
              style="line-height: 16px"
            >
              <div class="user-option">
                <span class="user-display-name">{{ user.displayName }}</span>
                <span class="user-mail">{{ user.mail }}</span>
              </div>
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div>
      <div class="grid-item assetContact formField userInput">
        <mat-form-field>
          <mat-label> Asset Forum Contact </mat-label>
          <!-- Search Input -->
          <input
            type="text"
            matInput
            formControlName="assetContact"
            [matAutocomplete]="assetContactAuto"
          />
          <!-- Filtered Options -->
          <mat-autocomplete
            requireSelection
            #assetContactAuto="matAutocomplete"
            [displayWith]="displayUser"
          >
            <mat-option
              *ngFor="let user of filteredAssetUserDetails"
              [value]="user"
              style="line-height: 16px"
            >
              <div class="user-option">
                <span class="user-display-name">{{ user.displayName }}</span>
                <span class="user-mail">{{ user.mail }}</span>
              </div>
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div>
      <div class="grid-item additionalContact formField userInput">
        <mat-form-field>
          <mat-label> Additional Contact </mat-label>
          <!-- Search Input -->
          <input
            type="text"
            matInput
            formControlName="additionalContact"
            [matAutocomplete]="additionalContactAuto"
          />
          <!-- Filtered Options -->
          <mat-autocomplete
            requireSelection
            #additionalContactAuto="matAutocomplete"
            [displayWith]="displayUser"
          >
            <mat-option
              *ngFor="let user of filteredAdditionalContactUserDetails"
              [value]="user"
              style="line-height: 16px"
            >
              <div class="user-option">
                <span class="user-display-name">{{ user.displayName }}</span>
                <span class="user-mail">{{ user.mail }}</span>
              </div>
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      </div>
    </div>
  </div>
  <div>
    <div class="formSubHeader">
      <span> Timeline </span>
    </div>
    <div class="grid-container-timeline">
      <div class="grid-item startDate userInput formField">
        <mat-form-field>
          <mat-label> Project Start Date </mat-label>
          <input
            matInput
            [matDatepicker]="startDatePicker"
            formControlName="startDate"
            style="color: #696969"
            required
            [min]="minStartDate"
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="startDatePicker"
          ></mat-datepicker-toggle>
          <mat-datepicker #startDatePicker></mat-datepicker>
        </mat-form-field>
      </div>
      <div class="grid-item serviceDate userInput formField">
        <mat-form-field>
          <mat-label> Project Estimated in Service Date </mat-label>
          <input
            matInput
            [matDatepicker]="serviceDatePicker"
            formControlName="serviceDate"
            style="color: #696969"
            required
            [min]="
              realEstateDetailForm.get('startDate')?.value
                ? realEstateDetailForm.get('startDate')?.value
                : todaysDate
            "
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="serviceDatePicker"
          ></mat-datepicker-toggle>
          <mat-datepicker #serviceDatePicker></mat-datepicker>
        </mat-form-field>
      </div>
      <div
        class="grid-item actualInServiceDate readOnlyInput formField"
        *ngIf="formStatus === RREFormStatus.IN_SERVICE && realEstateDetailForm.get('actualInServiceDate')?.value"
      >
        <mat-form-field>
          <mat-label> Actual In-Service Date </mat-label>
          <input
            matInput
            [matDatepicker]="actualInServiceDatePicker"
            formControlName="actualInServiceDate"
            style="color: #696969"
            readonly
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="actualInServiceDatePicker"
          ></mat-datepicker-toggle>
          <mat-datepicker #actualInServiceDatePicker></mat-datepicker>
        </mat-form-field>
      </div>
      <div class="grid-item completionDate readOnlyInput formField">
        <mat-form-field>
          <mat-label> Project Estimated Completion Date </mat-label>
          <input
            matInput
            [matDatepicker]="completionDatePicker"
            formControlName="completionDate"
            style="color: #696969"
            readonly
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="completionDatePicker"
          ></mat-datepicker-toggle>
          <mat-datepicker #completionDatePicker></mat-datepicker>
        </mat-form-field>
      </div>
    </div>
  </div>
</form>
